import React, { useState, useEffect } from "react";
import { professionsToolTable, tableMenuItems } from "../../adminData";
import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import CreditRequestSvg from "../../svgIcons/CreditRequestSvg";
import GlobalTableDropDown from "../../GlobalTableDropDown";
import { formatDate, formatTime } from "../../../../../utilities/utils";
import {
  useGetAllProfessionsQuery,
  useUpdateServiceCreditCostMutation,
} from "../../../../../store/admin/adminProfessions";
import { toast } from "react-toastify";
import Loader from "../../../../commons/Loader";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ServicesToolTable = ({
  profession,
  handleDropDownMenu,
  isEditId,
  setEditInputId,
  professionId
}) => {
  const [selectedEditValue, setSelectedEditValue] = useState(null);
  const [professionServices, setProfessionServices] = useState();
  const [showMenu, setShowMenu] = useState(null);
  const [
    updateServiceCreditCost,
    { isSuccess, data, isLoading: updatedIsLoading },
  ] = useUpdateServiceCreditCostMutation();
  const {
    data: AllProfession,
    isSuccess: allProfessionIsSuccess,
    isLoading: allProfessionIsLoading,
    refetch,
  } = useGetAllProfessionsQuery();

  useEffect(() => {
    window.addEventListener("click", () => {
      setShowMenu(false);
    });
    return () => {
      window.removeEventListener("click", () => {
        setShowMenu(false);
      });
    };
  }, []);

  useEffect(() => {
    if (AllProfession && allProfessionIsSuccess) {
      const foundProfession = AllProfession.data.find(
        (prof) => prof.id == profession?.id || prof.id == professionId
      );
      const professionServices =
        foundProfession && foundProfession.name == "Mental Health Counselor"
          ? profession.professions.filter((prof) => !prof?.form_step_hidden)
          : foundProfession?.professional_services;

      setProfessionServices(professionServices);
    }
  }, [AllProfession, allProfessionIsSuccess]);

  useEffect(() => {
    if ((data, isSuccess)) {
      refetch();
      toast.success(data.message);
      setEditInputId(null);
      setSelectedEditValue(null);
    }
  }, [data, isSuccess]);

  const handleMenuItems = (userId, flag) => {
    if (!flag) {
      setShowMenu(userId.id);
    } else {
      setShowMenu(null);
    }
  };

  const handleProfessionServiceCost = (serviceId) => {
    if (selectedEditValue && selectedEditValue[serviceId] != null) {
      updateServiceCreditCost({
        serviceId,
        _method: "PUT",
        credit_cost: selectedEditValue[serviceId],
      });
    } else {
      setEditInputId(null);
      setSelectedEditValue(null);
    }
  };

  const loading = allProfessionIsLoading || updatedIsLoading;

if(loading) return <Loader isLoading={true}/>
  return (
    <>
      <div className="px-4 sm:px-6 lg:px-8 hidden md:block">
        <div className="mt-8 flow-root">
          <div className="table-scroller -mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 bg-white border border-[#EBEFF3] rounded-md p-5">
            <div className="inline-block min-w-full py-2 align-middle">
              <div className="relative">
                <table className="min-w-full table-fixed divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-bold text-[#485868]"
                      >
                        # ID
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                      >
                        Price per lead
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                      >
                        Created at
                      </th>
                      <th
                        scope="col"
                        className="relative py-3.5 pl-3 pr-4 sm:pr-0"
                      >
                        <span className="sr-only"></span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {professionServices &&
                      professionServices.map((service, index) => (
                        <tr key={service.id}>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                            {service.id}
                          </td>
                          <td
                            className={classNames(
                              "whitespace-nowrap py-4 pr-3 text-sm font-normal text-customGray"
                            )}
                          >
                            {service.name}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                            <div className="flex items-center gap-3">
                              <div
                                className={`h-9 rounded-md border border-[#EBEFF3] py-2 px-3 w-[96px] ${
                                  service.id == isEditId
                                    ? "bg-white"
                                    : "bg-[#F1F4F6]"
                                } flex items-center justify-center`}
                              >
                                <span className="data-base-svg w-[18px] h-[18px] mr-2.5">
                                  <CreditRequestSvg />
                                </span>
                                <input
                                  type="text"
                                  value={
                                    (selectedEditValue &&
                                      selectedEditValue[service?.id]) ??
                                    service?.credit_cost
                                  }
                                  ref={(node) =>
                                    service.id == isEditId && node?.focus()
                                  }
                                  placeholder="100"
                                  onChange={(e) =>
                                    setSelectedEditValue({
                                      [service.id]: e.target.value,
                                    })
                                  }
                                  onClick={(e) => e.stopPropagation()}
                                  disabled={service.id != isEditId}
                                  className="bg-transparent text-sm font-normal leading-[140px] text-customGray border-l border-[#EBEFF3] pl-2.5 h-5"
                                />
                              </div>
                              {service.id == isEditId && (
                                <>
                                  <div className="flex items-center justify-center gap-2">
                                    {!loading && (
                                      <CheckCircleIcon
                                        className="w-6 h-6 text-[#16CA7C] cursor-pointer"
                                        onClick={() =>
                                          handleProfessionServiceCost(
                                            service.id
                                          )
                                        }
                                      />
                                    )}
                                    {!loading && (
                                      <XMarkIcon
                                        className="w-6 h-6 text-[#EF2121] cursor-pointer"
                                        onClick={(e) => {
                                          setEditInputId(null);
                                          setSelectedEditValue(null);
                                          e.stopPropagation();
                                        }}
                                      />
                                    )}
                                  </div>
                                  {loading && (
                                    <svg
                                      aria-hidden="true"
                                      role="status"
                                      className="inline w-5 h-5 me-3 text-white animate-spin ml-3 -mt-1"
                                      viewBox="0 0 100 101"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="#E5E7EB"
                                      />
                                      <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  )}
                                </>
                              )}
                            </div>
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                            {formatDate(service.created_at)} &#8226;{" "}
                            {formatTime(service.created_at)}
                          </td>
                          <td>
                            <GlobalTableDropDown
                              data={service}
                              showMenu={showMenu === service.id}
                              callBack={handleMenuItems}
                              isLastIndex={
                                index == professionsToolTable.length - 2
                              }
                              menuItems={tableMenuItems}
                              handleDropDownMenu={
                                handleDropDownMenu && handleDropDownMenu
                              }
                              setShowMenu={setShowMenu}
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="block md:hidden">
        <div>
          <ul>
            {professionServices &&
              professionServices.map((profession, index) => (
                <li className="border border-solid border-[#EBEFF3] rounded-md p-5 mb-[14px] flex justify-between bg-[#ffffff]">
                  <ul>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        # ID
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {profession.id}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Name
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {profession.name}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Price per lead
                      </h6>
                      <div className="flex items-center gap-3">
                        <div
                          className={`h-9 rounded-md border border-[#EBEFF3] py-2 px-3 w-[96px] ${
                            profession.id == isEditId
                              ? "bg-white"
                              : "bg-[#F1F4F6]"
                          } flex items-center justify-center`}
                        >
                          <span className="data-base-svg w-[18px] h-[18px] mr-2.5">
                            <CreditRequestSvg />
                          </span>
                          <input
                            type="text"
                            // value={profession.price_per_lead}
                            ref={(node) =>
                              profession.id == isEditId && node?.focus()
                            }
                            placeholder="100"
                            onClick={(e) => e.stopPropagation()}
                            disabled={profession.id != isEditId}
                            className="bg-transparent text-sm font-normal leading-[140px] text-customGray border-l border-[#EBEFF3] pl-2.5 h-5"
                          />
                        </div>
                        {profession.id == isEditId && (
                          <div className="flex items-center justify-center gap-2">
                            <CheckCircleIcon className="w-6 h-6 text-[#16CA7C] cursor-pointer" />
                            <XMarkIcon
                              className="w-6 h-6 text-[#EF2121] cursor-pointer"
                              onClick={(e) => {
                                setEditInputId(null);
                                e.stopPropagation();
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Created At
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {formatDate(profession.created_at)} &#8226;{" "}
                        {formatTime(profession.created_at)}
                      </span>
                    </li>
                  </ul>
                  <div>
                    <GlobalTableDropDown
                      data={profession}
                      showMenu={showMenu === profession.id}
                      callBack={handleMenuItems}
                      isLastIndex={index == professionsToolTable.length - 2}
                      menuItems={tableMenuItems}
                      handleDropDownMenu={
                        handleDropDownMenu && handleDropDownMenu
                      }
                      setShowMenu={setShowMenu}
                    />
                  </div>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default ServicesToolTable;
